





























































































































































































import Component from 'vue-class-component'
import { Injector } from '@/config/dependency-injection'
import { AccountModule } from '@/business/account/store/account-module'
import { NotificationService } from '@/shared/services/notification-service'
import { LoaderHelper } from '@/shared/services/loader-helper'

import Vue from 'vue'
import { REGISTER_ACCOUNT } from '@/business/account/store/types'
import { RegistrationForm } from '@/authentication/models/registration-form'
import { Form } from '@/shared/forms/form'
import { Registration } from '@/api/generated'
import { loggerFor } from '@/shared/utils/logger'
import { transformError } from '@/shared/utils/transform-error'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import { MetaService } from '@/shared/services/meta-service'
import { Prop } from 'vue-property-decorator'

@Component({
  components: { UnifyButton },
  data() {
    return {
      form: undefined,
    }
  },
})
export default class RegistrationComponent extends Vue {
  @Prop({
    default: null,
    type: String,
  })
  public readonly project!: string | null

  public error = ''
  public form!: Form<Registration, RegistrationForm>

  private accountModule = Injector.get(AccountModule)
  private loadingHelper = Injector.get(LoaderHelper)
  private metaService = Injector.get(MetaService)
  private notificationService = Injector.get(NotificationService)

  private logger = loggerFor('Registration')

  get isDemo() {
    return window.location.hostname.indexOf('demo.respondeco.org') > -1
  }

  get isLoading() {
    return this.loadingHelper.isLoading(REGISTER_ACCOUNT)
  }

  public created() {
    this.form = new Form<Registration, RegistrationForm>(RegistrationForm, this)

    this.metaService.updateDocumentTitle('registration')
  }

  public submit() {
    this.$v.$touch()

    if (!this.$v.$invalid) {
      const payload = this.form.serialize()

      this.logger.info(payload)

      this.accountModule
        .registerAccount({
          registration: {
            ...payload,
            project: this.project ?? undefined,
          },
        })
        .then(
          () => {
            this.notificationService.success('registration.success')

            if (this.project == null) {
              this.$router.push('/')
            } else {
              this.$router.push({
                name: this.project,
              })
            }
          },
          error => {
            this.error = transformError(error, {
              400: {
                'organisation.exists': this.$t('registration.errors.organisation_exists'),
                'user.already.registered.with.email': this.$t(
                  'registration.errors.user_already_registered'
                ),
                'user.already.registered.with.name': this.$t(
                  'registration.errors.user_already_registered'
                ),
                'user.creation.failed': this.$t('registration.errors.user_creation_failed'),
              },
              409: this.$t('registration.errors.organisation_exists'),
            })
          }
        )
    }
  }

  public validations() {
    return this.form.validations()
  }
}
